import { gql } from "@apollo/client";

export const GET_TIPOS_REPORTE_BOT = gql`
query GetTiposReporteBOT {
  tiposReporteBOT {
    success
    error
    valorEsperado {
      codigo
      descripcion
    }
  }
}`;
